import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  axApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
export const failuresApi = {
  getFailuresList: async (params: {
    remote_utility_id: string;
    page?: number;
    limit?: number;
    search?: string;
    searchData?: string;
    status?: string;
    priority?: string;
    assetType?: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "failures",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);

        // Add pagination parameters
        if (params.page !== undefined) {
          qs.push("page", params.page.toString());
        }
        if (params.limit !== undefined) {
          qs.push("limit", params.limit.toString());
        }

        // Add search functionality - handle both search and searchData
        if (params.search) {
          qs.push("search", params.search);
        }
        if (params.searchData) {
          qs.push("search_field", "failure"); // or whatever field name the API expects
          qs.push("search_data", params.searchData);
        }

        // Add filter parameters
        if (params.status) {
          qs.push("status", params.status);
        }
        if (params.priority) {
          qs.push("priority", params.priority);
        }
        if (params.assetType) {
          qs.push("asset_type", params.assetType); // Note: using snake_case as APIs often expect this
        }
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },

  getAssetList: async (params: {
    remote_utility_id: string;
    page: any;
    limit: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "assets",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("page", params.page);
        qs.push("limit", params.limit);
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },
  getFailuresDetails: async (params: {
    remote_utility_id: string;
    id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      `failures/${params.id}`,
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },

  addFailures: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", "failures");
    const response = await axApiClient.post(url, payload);
    return response.data;
  },

  updateFailures: async (id: any, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", `failures/${id}`);
    const response = await axApiClient.patch(url, payload);
    return response.data;
  },

  ignoreFailures: async (id: any, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", `failures/${id}`);
    const response = await axApiClient.patch(url, payload);
    return response.data;
  },

  getFailuresDashboard: async (params: {
    remote_utility_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "failures/dashboard",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await axApiClient.get(url);
    return response.data.result;
  },

  getSOPSelection: async (params: {
    remote_utility_id: string;
    reading_source: string;
    association_type: string;
    operation_type: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "service-order-template",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("reading_source", params.reading_source);
        qs.push("association_type", params.association_type);
        qs.push("operation_type", params.operation_type);
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },

  getObservedSymptom: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", "choices/observed_symptom");
    const response = await axApiClient.get(url);
    return response.data;
  },
  getAssetByMap: async (params: {
    remote_utility_id: string;
    longitude: any;
    latitude: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "assets",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("longitude", params.longitude);
        qs.push("latitude", params.latitude);
      }
    );
    const response = await axApiClient.get(url);
    return response.data;
  },

  getFailureModes: async (params: {
    remote_utility_id: string;
    asset_type_characteristics: any;
    config_level: any;
    code_list: any;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/asset_class_json",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push(
          "asset_type_characteristics",
          params.asset_type_characteristics
        );
        qs.push("config_level", params.config_level);
        if (params.code_list) qs.push("code_list", params.code_list);
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getFailureStatus: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", "choices/failure_status");
    const response = await axApiClient.get(url);
    return response.data;
  },
  getOperationStatus: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", "choices/operation_type");
    const response = await axApiClient.get(url);
    return response.data;
  },

  addServiceOrder: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("ax", "service-order-create");
    const response = await axApiClient.post(url, payload);
    return response.data;
  },
};
